module.exports = __webpack_public_path__ + "static/media/personal_text_coupon.292d3998.xlsx";